module.exports = ".form-inline progress[value] {\n  width: 250px;\n  height: 20px;\n}\n\n.dashhead-toolbar >>> button {\n  margin-left: 5px;\n}"